import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find-index";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import range from 'lodash/range';
import padStart from 'lodash/padStart';
import get from 'lodash/get';
export default {
  name: 'IsFMAccmgmtrowdetail',
  props: {
    editedItem: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      actionButtons: [{
        title: this.$i18n_t('Common.reset'),
        action: 'reset',
        icon: 'fal fa-sync'
      }, {
        title: this.$i18n_t('Common.save'),
        tooltip: this.$i18n_t('Common.save'),
        icon: 'fas fa-save',
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }],
      panel: null,
      dateFromMenu: false,
      dateFromPosition: {},
      dateToMenu: false,
      dateToPosition: {},
      searchDays: '',
      valid: false,
      lclId: null,
      lclTwinId1: null,
      lclTwinId2: null,
      lclEmail: null,
      lclUsagePerWeek: null,
      lclDays: [],
      lclUserId: null,
      lclDateFrom: null,
      lclDateTo: null,
      daysList: [{
        dayId: 1,
        dayText: this.$i18n_t('Common.Monday')
      }, {
        dayId: 2,
        dayText: this.$i18n_t('Common.Tuesday')
      }, {
        dayId: 3,
        dayText: this.$i18n_t('Common.Wednesday')
      }, {
        dayId: 4,
        dayText: this.$i18n_t('Common.Thursday')
      }, {
        dayId: 5,
        dayText: this.$i18n_t('Common.Friday')
      }, {
        dayId: 6,
        dayText: this.$i18n_t('Common.Saturday')
      }, {
        dayId: 0,
        dayText: this.$i18n_t('Common.Sunday')
      }],
      lclTimeFromHour: null,
      lclTimeFromMinute: '00',
      lclTimeToHour: null,
      lclTimeToMinute: '00',
      hourList: range(0, 24),
      minuteList: range(0, 60, 5),
      rulesDateTo: [function (v) {
        if (v < _this.lclDateFrom) {
          return _this.$i18n_t('IS.FM.AccessMgmt.dateBigThanFrom');
        } else {
          return true;
        }
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    lclTimeFrom: function lclTimeFrom() {
      return this.lclTimeFromHour ? "".concat(padStart(this.lclTimeFromHour, 2, '0'), ":").concat(padStart(this.lclTimeFromMinute, 2, '0')) : null;
    },
    lclTimeTo: function lclTimeTo() {
      return this.lclTimeToHour ? "".concat(padStart(this.lclTimeToHour, 2, '0'), ":").concat(padStart(this.lclTimeToMinute, 2, '0')) : null;
    },
    rolloverDayCaption: function rolloverDayCaption() {
      return this.lclTimeTo < this.lclTimeFrom && this.lclTimeTo !== '00:00' ? "".concat(this.$i18n_t('IS.FM.AccessMgmt.dayRollover'), " \u261D\uD83C\uDFFC") : null;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  }),
  watch: {
    editedItem: function editedItem(val) {
      this.initForm(val);
    },
    lclTwinId1: function lclTwinId1(newV, oldV) {
      if (oldV !== null) {
        // if a building/room is selected, reset the selection of the door, otherwise the tree won't build correctly
        this.lclTwinId2 = undefined;
      }
    }
  },
  mounted: function mounted() {
    if (this.editedItem) {
      this.initForm(this.editedItem);
    }

    this.$refs.form.validate();
    this.hourList = this.hourList.map(function (hour) {
      return padStart(hour, 2, '0');
    });
    this.minuteList = this.minuteList.map(function (minute) {
      return padStart(minute, 2, '0');
    });
  },
  methods: {
    allowedStep: function allowedStep(m) {
      return m % 10 === 0;
    },
    userSelected: function userSelected(a) {
      this.lclUserId = a.id;
      this.lclEmail = a.email;
    },
    isValidDoorParent: function isValidDoorParent(entry) {
      if (get(entry, 'data.tags', []).findIndex(function (tag) {
        return ['building', 'room'].indexOf(tag.toLowerCase()) >= 0;
      }) >= 0) {
        return true;
      }

      return ['building', 'room'].indexOf(get(entry, 'data.type', '')) >= 0;
    },
    isValidDoor: function isValidDoor(entry) {
      return get(entry, 'data.isFm.doorId') && entry.data.isFm.doorId.trim() !== '';
    },
    close: function close() {
      this.initForm();
      this.$emit('close');
    },
    validate: function validate() {
      this.valid = this.$refs.form.validate();

      if (this.valid) {
        this.snackbar = true;
      }
    },
    fromDatePicked: function fromDatePicked(dateObject) {
      this.lclDateFrom = new Date(dateObject.from * 1000);
    },
    toDatePicked: function toDatePicked(dateObject) {
      this.lclDateTo = new Date(dateObject.from * 1000);
    },
    handleSubmit: function handleSubmit() {
      this.validate();

      if (this.valid) {
        // make sure to only get the "date" component from the date-picker
        var dateFrom = this.lclDateFrom ? new Date(this.lclDateFrom).toISOString() : null;

        if (dateFrom) {
          dateFrom = dateFrom.split('T')[0];
        }

        var dateTo = this.lclDateTo ? new Date(this.lclDateTo).toISOString() : null;

        if (dateTo) {
          dateTo = dateTo.split('T')[0];
        }

        this.$emit('save', {
          id: this.lclId,
          userId: this.lclUserId,
          dtwinId: this.lclTwinId1,
          accessObject: this.lclTwinId2,
          data: {
            days: this.lclDays,
            usagePerWeek: this.lclUsagePerWeek,
            dateFrom: dateFrom,
            dateTo: dateTo,
            timeFrom: this.lclTimeFrom,
            timeTo: this.lclTimeTo
          }
        });
        this.initForm();
      }
    },
    resetTimeRestriction: function resetTimeRestriction() {
      this.lclTimeFromHour = null;
      this.lclTimeFromMinute = '00';
      this.lclTimeToHour = null;
      this.lclTimeToMinute = '00';
    },
    reset: function reset() {
      this.initForm();
    },
    initForm: function initForm(val) {
      if (val) {
        this.lclId = val.id;
        this.lclTwinId1 = val.dtwinId;
        this.lclTwinId2 = val.accessObject;
        this.lclUserId = val.userId;

        if (val.user) {
          this.lclEmail = val.user.email;
        }

        if (val.data) {
          this.lclDays = val.data.days;
          this.lclDateFrom = val.data.dateFrom;
          this.lclDateTo = val.data.dateTo;
          this.lclUsagePerWeek = val.data.usagePerWeek;
          var timeFromComponents = val.data.timeFrom ? val.data.timeFrom.split(':') : null;
          this.lclTimeFromHour = get(timeFromComponents, '[0]');
          this.lclTimeFromMinute = get(timeFromComponents, '[1]');
          var timeToComponents = val.data.timeTo ? val.data.timeTo.split(':') : null;
          this.lclTimeToHour = get(timeToComponents, '[0]');
          this.lclTimeToMinute = get(timeToComponents, '[1]');

          if (val.data.days || val.data.timeFrom || val.data.usagePerWeek) {
            this.panel = 0;
          }
        }
      } else {
        this.lclUserId = null;
        this.lclTwinId1 = null;
        this.lclTwinId2 = null;
        this.panel = null;
        this.lclDateFrom = null;
        this.lclDateTo = null;
        this.lclDays = [];
        this.lclUsagePerWeek = null;
        this.resetTimeRestriction();
      }
    }
  }
};